import {CocValidation} from "../model/coc/coc-validation.model";
import axios from "axios";

const BASE_API_URL = "/web/rest-fp";

export function companyForCoc(cocId, cocSubId, funnelId) {
    if (!cocSubId) {
        return axios.get(`${BASE_API_URL}/rdc/${funnelId}/company/${cocId}`)
          .then(result => result.data);
    }

    return axios.get(`${BASE_API_URL}/rdc/${funnelId}/company/${cocId}/${cocSubId}`)
        .then(result => result.data);
}

export function cocApi(cocId, cocSubId, funnelId) {
    return companyForCoc(cocId, cocSubId, funnelId)
        .then(response => CocValidation.success(response))
        .catch(error => {
            switch (error.response.status) {
                case 429:
                    return CocValidation.tooManyRequests()
                case 406:
                    return CocValidation.companyNotAcceptable();
                default:
                    return CocValidation.noCompanyFound()
            }
        });
}